module.exports = __webpack_public_path__ + "img/t1-1.859c675a.png";